export const selectDispositivosState = (state) => state.dispositivos;
